<div class="message">
  <span fxLayoutAlign="start center" class="text" fxFlex>
    <mat-icon class="icon-error">error</mat-icon>
    <p [ngStyle]="getStyle()">{{ message }}</p>
  </span>
</div>
